import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { ThemedEventConstants } from "../../constants/ThemedEventConstants";
import { IdStyles } from "../../less/IdStyles";
import { selectActiveThemedEventInfo, selectThemedEvent, selectThemedEventActiveQuestBalancing, selectThemedEventIsRewardCollected, selectThemedEventPlayerDifficultyLevel, } from "../../selectors/selectEventInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { BigCharacter } from "../generic/big-character/BigCharacter";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { actionQuestSelect } from "../info/quest/list/actionQuests";
import { actionModalClose, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { ThemedEventProgress } from "./ThemedEventProgress";
var rewardClassNamePrefix = "themed-event-reward";
var decorationClassNamePrefix = "themed-event-decoration";
var TabThemedEventDOM = function (_a) {
    var themedEventDifficulty = _a.themedEventDifficulty, activeQuest = _a.activeQuest, onGoToClick = _a.onGoToClick, themedEventInfo = _a.themedEventInfo, isThemedEventFinishedState = _a.isThemedEventFinishedState, activeThemedEvent = _a.activeThemedEvent;
    if (!activeThemedEvent || !themedEventInfo) {
        return React.createElement(React.Fragment, null);
    }
    var rewardClassName = rewardClassNamePrefix + "-" + themedEventInfo.name.toLowerCase();
    var decorationClassName = decorationClassNamePrefix + "-" + themedEventInfo.name.toLowerCase();
    var decorationDOM = (React.createElement("div", { className: "themed-event " + decorationClassNamePrefix + " " + decorationClassName }));
    var titleLocaId;
    var descriptionLocaId;
    var progressDOM;
    if (isThemedEventFinishedState) {
        titleLocaId = IdLoca.congratulations;
        descriptionLocaId = themedEventInfo.completedDescription;
        progressDOM = (React.createElement(TextLoca, { id: IdLoca.themedEventCompleted_eventInfo, className: IdStyles.TextBoldPrimary }));
    }
    else {
        var activeQuestEpisode = activeQuest ? activeQuest.episode : 1;
        var locaReplacements = new Map([
            [ReplacementLoca.zero_0, activeQuestEpisode.toString()],
            [ReplacementLoca.one_1, ThemedEventConstants.eventTotalEpisodes.toString()],
        ]);
        titleLocaId = themedEventInfo.title;
        descriptionLocaId = themedEventInfo.description;
        progressDOM = (React.createElement(ThemedEventProgress, { activeQuestEpisode: activeQuestEpisode, locaReplacements: locaReplacements, taskIcons: themedEventInfo.taskIcons, onGoToClick: function () { return onGoToClick(activeQuest); } }));
    }
    return (React.createElement("div", { className: "w100 h100 flex flex--stacked flex--spaced h-s-margin" },
        React.createElement("div", { className: "flex flex--end flex--aligned h100" },
            React.createElement(BigCharacter, { name: themedEventInfo.character, className: "themed-event-character" }),
            React.createElement("div", { className: "flex flex--stacked flex--guts themed-event-balloon-container" },
                decorationDOM,
                React.createElement("div", { className: IdStyles.ThemedEventBalloonDescription + " themed-event-balloon themed-event-pointer flex flex--stacked" },
                    React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" },
                        React.createElement("p", null,
                            React.createElement(TextLoca, { id: titleLocaId, className: IdStyles.TextBoldPrimary })),
                        React.createElement(TextLoca, { id: descriptionLocaId, className: IdStyles.TextNormal }))),
                decorationDOM),
            React.createElement("div", { className: "themed-event " + rewardClassNamePrefix + " " + rewardClassNamePrefix + "-text " + rewardClassName + " flex flex--guts" },
                React.createElement(NumberFormat, { amount: themedEventDifficulty.reward.amount, className: IdStyles.TextBoldSecondaryOutline }),
                isThemedEventFinishedState && (React.createElement("div", { className: rewardClassNamePrefix + "-finished-icon" },
                    React.createElement(Icon, { styleId: IdStyles.IconExtraLarge, icon: IdIcon.CheckIcn }))))),
        React.createElement("div", { className: IdStyles.ThemedEventTaskBackground + " themed-event-task-background__container flex flex--around flex--aligned" }, progressDOM)));
};
var mapState = function (state) { return ({
    activeQuest: selectThemedEventActiveQuestBalancing(state),
    activeThemedEvent: selectThemedEvent(state),
    isThemedEventFinishedState: selectThemedEventIsRewardCollected(state),
    themedEventDifficulty: selectThemedEventPlayerDifficultyLevel(state),
    themedEventInfo: selectActiveThemedEventInfo(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onGoToClick: function (quest) {
        dispatch(actionQuestSelect(quest));
        dispatch(actionModalClose(IdModal.ThemedEvent));
        dispatch(actionModalOpen(IdModal.Quests));
    },
}); };
export var TabThemedEvent = connect(mapState, mapDispatch)(TabThemedEventDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/TabThemedEvent.tsx
// module id = 2768
// module chunks = 3